import {ReactComponent as BellIcon} from "./bell.svg";

const Bellicon = () => {
    return (
        <div><BellIcon className='icon' /></div>
    )
}
export default Bellicon
